import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import LoadingPanel from 'src/components/common/LoadingPanel';
import IOwner from 'src/models/IOwner';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import TransferOwnerContainer from './TransferOwnerContainer';
import OwnerChangePrimary from './OwnerChangePrimary';
import TransferConfirmationContainer from './TransferConfirmationContainer';
import ManageDeviationsLanding from './ManageDeviationsLanding';
import SeparateDeviations from './SeparateDeviations';
import MergeContainer from 'src/models/MergeContainer';

export enum ManageDeviationsPage {
    Menu,
    ChangePrimary,
    TransferPage,
    TransferConfirmation,
    SeparateDeviation,
}

export interface IManageDeviationsDialogProps {
    clearError?: () => void;
    clearTargetDeviations: () => void;
    changePrimary: (owner: IOwner) => void;
    separateDeviation: (owner: IOwner) => void;
    searchOwners: (searchText: string, ownerType: string) => void;
    getOwnerDeviations: (ownerLookupId: number, containerId: number, type: string) => void;
    getTargetOwnerDeviations: (ownerLookupId: number, containerId: number, type: string) => void;
    mergeContainer: (primaryOwnerId: number, mergeContainer: MergeContainer) => void;
}

export type IManageDeviationsStateProps = {
    dialogName: string;
    errorMessage?: string;
    ownerId: number;
    ownerDeviations: Array<IOwner>;
    targetOwnerDeviations: Array<IOwner>;
    searchResults?: Array<SearchResult>;
    searchOwnerType: string;
};

type IManageDeviationsState = {
    hasUncheckedDeviations: boolean;
    page: ManageDeviationsPage;
    searchString: string;
};

type IManageDeviationsDialogPageProps = IManageDeviationsDialogProps & IManageDeviationsStateProps;

class ManageDeviationsDialog extends React.Component<IManageDeviationsDialogPageProps, IManageDeviationsState> {
    private changePrimaryForm: FormApi;
    private transferContainerForm: FormApi;
    private transferConfirmationForm: FormApi;
    private separateDeviationForm: FormApi;

    constructor(props: IManageDeviationsDialogPageProps) {
        super(props);
        this.state = {
            hasUncheckedDeviations: false,
            page: ManageDeviationsPage.Menu,
            searchString: undefined,
        };
    }

    onTransferContainerCreatedForm = (form: FormApi) => {
        this.transferContainerForm = form;
    };
    onTransferConfirmationCreatedForm = (form: FormApi) => {
        this.transferConfirmationForm = form;
    };
    changePrimaryFormCreated = (form: FormApi) => {
        this.changePrimaryForm = form;
    };
    separateDeviationFormCreated = (form: FormApi) => {
        this.separateDeviationForm = form;
    };
    getOwnerDeviations = (ownerLookupId: number, containerId: number, type: string) => {
        this.props.getOwnerDeviations(ownerLookupId, containerId, type);
    };

    getTargetOwnerDeviations = (ownerLookupId: number, containerId: number, type: string) => {
        this.props.getTargetOwnerDeviations(ownerLookupId, containerId, type);
    };

    onClose = () => {
        this.props.clearTargetDeviations();
        this.changePage(ManageDeviationsPage.Menu);
    };
    changePage = (page: ManageDeviationsPage) => {
        this.setState({ page: page });
    };

    public render() {
        return (
            <Dialog dialogName={DialogList.MANAGE_DEVIATIONS} title={`Manage Deviations`} onCloseDialog={this.onClose}>
                <div>
                    <LoadingPanel loadingAction={DialogList.MANAGE_DEVIATIONS}>
                        <ManageDeviationsLanding changePage={this.changePage} ownerDeviations={this.props.ownerDeviations} page={this.state.page} />
                        <TransferOwnerContainer
                            form={this.transferContainerForm}
                            getOwnerDeviations={this.getOwnerDeviations}
                            getTargetOwnerDeviations={this.getTargetOwnerDeviations}
                            onTransferContainerCreatedForm={this.onTransferContainerCreatedForm}
                            originalOwnerDeviations={this.props.ownerDeviations}
                            targetOwnerDeviations={this.props.targetOwnerDeviations}
                            searchOwners={this.props.searchOwners}
                            searchResults={this.props.searchResults}
                            clearTargetDeviations={this.props.clearTargetDeviations}
                            changePage={this.changePage}
                            page={this.state.page}
                            searchOwnerType={this.props.searchOwnerType}
                        />
                        <TransferConfirmationContainer
                            form={this.transferConfirmationForm}
                            onTransferConfirmationCreatedForm={this.onTransferConfirmationCreatedForm}
                            originalOwnerDeviations={this.props.ownerDeviations}
                            targetOwnerDeviations={this.props.targetOwnerDeviations}
                            mergeContainer={this.props.mergeContainer}
                            changePage={this.changePage}
                            page={this.state.page}
                        />
                        <OwnerChangePrimary
                            changePrimary={this.props.changePrimary}
                            changePrimaryFormCreated={this.changePrimaryFormCreated}
                            form={this.changePrimaryForm}
                            ownerDeviations={this.props.ownerDeviations}
                            changePage={this.changePage}
                            clearTargetDeviations={this.props.clearTargetDeviations}
                            page={this.state.page}
                        />
                        <SeparateDeviations
                            separateDeviation={this.props.separateDeviation}
                            separateDeviationsFormCreated={this.separateDeviationFormCreated}
                            form={this.separateDeviationForm}
                            ownerDeviations={this.props.ownerDeviations}
                            changePage={this.changePage}
                            clearTargetDeviations={this.props.clearTargetDeviations}
                            page={this.state.page}
                        />
                    </LoadingPanel>
                </div>
            </Dialog>
        );
    }
}

export default ManageDeviationsDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageDeviationsDialog.tsx